import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService';
import { setAssetItemStatusHeaderDetail } from 'Store/FleetManagement/AssetItemStatusHeaderDetails/AssetItemStatusHeaderDetailsAction';
import { GET_ASSET_ITEM_STATUS_HEADER_DETAIL } from "../../Store/FleetManagement/AssetItemStatusHeaderDetails/AssetItemStatusHeaderDetailsType";
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setAssetItemStatusPurchaseDetails, SetIsAssetItemStatusPurchaseDetailsCalled } from 'Store/FleetManagement/AssetItemStatusPurchaseDetail/AssetItemStatusPurchaseDetailAction';
import { GET_ASSET_ITEM_STATUS_PURCHASE_DETAILS } from 'Store/FleetManagement/AssetItemStatusPurchaseDetail/AssetItemStatusPurchaseDetailType';
import { setAssetItemStatusVendorDetail, SetIsAssetItemStatusVendorDetailCalled } from 'Store/FleetManagement/AssetItemStatusVendorDetail/AssetItemStatusVendorDetailAction';
import { GET_ASSET_ITEM_STATUS_VENDOR_DETAIL } from 'Store/FleetManagement/AssetItemStatusVendorDetail/AssetItemStatusVendorDetailType';
import { setAssetItemStatusPurchaseOrder, SetIsAssetItemStatusPurchaseOrderCalled } from 'Store/FleetManagement/AssetItemStatusPurchaseOrder/AssetItemStatusPurchaseOrderAction';
import { GET_ASSET_ITEM_STATUS_PURCHASE_ORDER } from 'Store/FleetManagement/AssetItemStatusPurchaseOrder/AssetItemStatusPurchaseOrderType';
import { setAssetItemStatusTaskDetail, SetIsAssetItemStatusTaskDetailCalled } from 'Store/FleetManagement/AssetItemStatusTaskDetails/AssetItemStatusTaskDetailsAction';
import { GET_ASSET_ITEM_STATUS_TASK_DETAIL } from 'Store/FleetManagement/AssetItemStatusTaskDetails/AssetItemStatusTaskDetailsType';

function* getAssetItemstatusHeaderDetail(req: any): any {
  try {
    yield put(globalLoaderText("Getting values...."));
    let payloadData: IPayload = {
      apiType: apiType.FleetManagement,
      endpoint: `assetitemstatus/${req.fleetDetailId}`,
      apiMethod: apiMethod.GET,
      payload: req.payload

    }
    const response = yield call(
      FleetManagementApiService.post, API_URL.PostWebApp, payloadData
    );
    const currentHeaderDetailTemp = req.currentHeaderDetail ? req.currentHeaderDetail : []
    if (response) {
      let val = { fleetDetailId: req.fleetDetailId, headerDetails: response }
      yield put(setAssetItemStatusHeaderDetail([...currentHeaderDetailTemp, val]));
    }
    yield put(globalLoaderText(""));
  } catch (error: any) {
    yield put(setAssetItemStatusHeaderDetail({}));
    yield put(globalLoaderText(""));
  }
}

function* getAssetItemstatusPurchaseDetail(req: any): any {
  try {
    yield put(SetIsAssetItemStatusPurchaseDetailsCalled(req.fleetDetailId,true))
    let payloadData: IPayload = {
      apiType: apiType.FleetManagement,
      endpoint: `assetitemstatus/purchasedetail/${req.fleetDetailId}`,
      apiMethod: apiMethod.GET,
      payload: req.payload

    }
    const response = yield call(
      FleetManagementApiService.post, API_URL.PostWebApp, payloadData
    );
    if (response) {
      yield put(setAssetItemStatusPurchaseDetails({ response: response, fleetDetailId: req.fleetDetailId }));
    }
    yield put(SetIsAssetItemStatusPurchaseDetailsCalled(req.fleetDetailId,false));
  } catch (error: any) {
    yield put(setAssetItemStatusPurchaseDetails({}));
    yield put(SetIsAssetItemStatusPurchaseDetailsCalled(req.fleetDetailId,false));
  }
}

function* getAssetItemstatusVendorDetail(req: any): any {
  try {
    yield put(SetIsAssetItemStatusVendorDetailCalled(req.fleetDetailId,true));
    let payloadData: IPayload = {
      apiType: apiType.FleetManagement,
      endpoint: `assetitemstatus/dealerdetails/${req.fleetDetailId}`,
      apiMethod: apiMethod.GET,
      payload: req.payload

    }
    const response = yield call(
      FleetManagementApiService.post, API_URL.PostWebApp, payloadData
    );
    if (response) {
      yield put(setAssetItemStatusVendorDetail({ response: response, fleetDetailId: req.fleetDetailId }));
    }
    yield put(SetIsAssetItemStatusVendorDetailCalled(req.fleetDetailId,false));
  } catch (error: any) {
    yield put(setAssetItemStatusVendorDetail({}));
    yield put(SetIsAssetItemStatusVendorDetailCalled(req.fleetDetailId,false));
  }
}

function* getAssetItemstatusPurchaseOrder(req: any): any {
  try {
    yield put(SetIsAssetItemStatusPurchaseOrderCalled(req.fleetDetailId,true));
    let payloadData: IPayload = {
      apiType: apiType.FleetManagement,
      endpoint: `assetitemstatus/purchaseorder/${req.fleetDetailId}`,
      apiMethod: apiMethod.GET,
      payload: req.payload

    }
    const response = yield call(
      FleetManagementApiService.post, API_URL.PostWebApp, payloadData
    );
    if (response) {
      yield put(setAssetItemStatusPurchaseOrder({ response: response, fleetDetailId: req.fleetDetailId }));
    }
    yield put(SetIsAssetItemStatusPurchaseOrderCalled(req.fleetDetailId,false));
  } catch (error: any) {
    yield put(setAssetItemStatusPurchaseOrder({}));
    yield put(SetIsAssetItemStatusPurchaseOrderCalled(req.fleetDetailId,false));
  }
}

function* getAssetItemstatusTaskDetails(req: any): any {
  try {
    yield put(SetIsAssetItemStatusTaskDetailCalled(req?.fleetDetails?.id,true));
    let payloadData: IPayload = {
      apiType: apiType.FleetManagement,
      endpoint: `assetitemstatus/taskdetails/${req?.fleetDetails?.id}/${req?.fleetDetails?.isRequisition}`,
      apiMethod: apiMethod.GET,
      payload: req.payload

    }
    const response = yield call(
      FleetManagementApiService.post, API_URL.PostWebApp, payloadData
    );
    if (response) {
      yield put(setAssetItemStatusTaskDetail({ response: response, fleetDetailId: req?.fleetDetails?.id }));
    }
    yield put(SetIsAssetItemStatusTaskDetailCalled(req?.fleetDetails?.id,false));
  } catch (error: any) {
    yield put(setAssetItemStatusTaskDetail({}));
    yield put(SetIsAssetItemStatusTaskDetailCalled(req?.fleetDetails?.id,false));
  }
}

function* pendingOrderSagaWatcher() {
  yield takeEvery(GET_ASSET_ITEM_STATUS_HEADER_DETAIL, getAssetItemstatusHeaderDetail);
  yield takeEvery(GET_ASSET_ITEM_STATUS_PURCHASE_DETAILS, getAssetItemstatusPurchaseDetail);
  yield takeEvery(GET_ASSET_ITEM_STATUS_VENDOR_DETAIL, getAssetItemstatusVendorDetail);
  yield takeEvery(GET_ASSET_ITEM_STATUS_PURCHASE_ORDER, getAssetItemstatusPurchaseOrder);
  yield takeEvery(GET_ASSET_ITEM_STATUS_TASK_DETAIL, getAssetItemstatusTaskDetails);
}

export default function* combinedSaga() {
  yield all([
    pendingOrderSagaWatcher()
  ]);
}
